import { useSelector } from 'react-redux';
import AdminNav from './AdminNav/AdminNav';

export default function DevicePage({ content: Content, deferNavigation = false }) {
    const unit = useSelector(state => state.auth.activeUnit);
    const user = useSelector(state => state.auth.user?.user);
    const token = useSelector(state => state.auth.token);
    const membership = useSelector(state => state.auth.userType);
    const showCaregiverPages = Boolean(unit?.UnitSerNum && membership?.unit === unit.UnitSerNum && membership?.userType === 'Admin');
    const scope = JSON.stringify([user, token, unit?.CustomerKey, unit?.UnitSerNum]);
    const navigation = <AdminNav showCaregiverPages={showCaregiverPages} />;
    return <>
        {!deferNavigation && navigation}
        <Content key={scope} unit={unit} navigation={deferNavigation ? navigation : null} />
    </>;
}
